import {
  AbilityBuilder,
  AbilityClass,
  createMongoAbility,
  MongoAbility,
} from '@casl/ability';
import { createContextualCan } from '@casl/react';
import { AccessControl, IFeatures } from 'libs/db/src/types/user';
import { createContext } from 'react';
export type Actions =
  | 'create'
  | 'read'
  | 'update'
  | 'delete'
  | 'canManageProfiles'; // same like backend action.
type AppAbility = MongoAbility<[Actions, string]>;

const AppAbilityClass =
  createMongoAbility as unknown as AbilityClass<AppAbility>;

export const buildAbilityFromAccessControls = (
  accessControls: AccessControl[],
  features: IFeatures[],
): AppAbility => {
  const { can, rules } = new AbilityBuilder<AppAbility>(AppAbilityClass);
  accessControls.forEach((ac) => {
    ac.actions.forEach((action: string) => {
      can(
        action.toLowerCase() as Actions,
        features.find((f) => f.id === ac.feature)?.name ?? '',
      );
    });
    ac.canManageProfiles.forEach((action: string, index: number) => {
      can('canManageProfiles' as Actions, ac.canManageProfiles[index]);
    });
  });

  return new AppAbilityClass(rules);
};

export const AbilityContext = createContext<AppAbility>(null!);

export const Can = createContextualCan(AbilityContext.Consumer);
